import React, { useEffect } from "react";
// react router dom module
import { Route, Routes, Navigate } from "react-router-dom";

// components
import MainLayout from "./layout/MainLayout";
import LoginPage from "./pages/LoginPage/LoginPage";
import Dashboard from "./pages/Dashboard/Dashboard";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Factor from "./pages/Factor/Factor";
import NotFound from "./pages/NotFound/NotFound";

// react toastify
import { ToastContainer } from "react-toastify";

// state manager
import { useRecoilState } from "recoil";
import { authAtom } from "./shared/auth";


// styled components
import { GlobalStyles } from "./theme/GlobalStyle";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [userData, setUserData] = useRecoilState(authAtom);

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("profile")));
  }, []);

  return (
    <MainLayout>
      <ToastContainer />
      <GlobalStyles />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/factor/:id" element={<Factor />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/Dashboard/*"
          element={userData ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </MainLayout>
  );
}

export default App;
